import { Component } from '@theme/component';
class OfcCookiePreferences extends Component {
  async open() {
    const status = this.refs.status;
    if (status) status.textContent = '';
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Not ready');
      await window.privacyBanner.showPreferences();
    } catch {
      if (status) status.textContent = this.querySelector('button')?.dataset.error || '';
    }
  }
}
if (!customElements.get('ofc-cookie-preferences')) customElements.define('ofc-cookie-preferences', OfcCookiePreferences);
